import { render, staticRenderFns } from "./anmeldung.vue?vue&type=template&id=70a2c902"
import script from "./anmeldung.vue?vue&type=script&lang=js"
export * from "./anmeldung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports